import { FINALIZED_UPLOAD_STATES } from "@/components/MetadataFields/formFieldsAccessRules";

export const DISABLED_STATES = FINALIZED_UPLOAD_STATES;
